import { useTranslator } from '@bluebeam/react-i18n';
// import Filter, {
//   FilterCategory,
//   SelectedOptionToFilter,
// } from 'components/Filter/Filter';
import ThinPlus from 'components/Icons/ThinPlus';
import { Button, SearchInput } from 'components/lib';
import OverlayHeader from 'components/Overlays/OverlayHeader';
import LayerList from 'components/Overlays/ViewMapLayersOverlay/LayerList';
import SortButton from 'components/Overlays/ViewMapLayersOverlay/SortButton';
import * as Immutable from 'immutable';
import { useMapLayersManager } from 'providers/MapLayersManagerProvider';
import { useProjectManager } from 'providers/ProjectManagerProvider';
import * as React from 'react';
import { useEffect, useState } from 'react';
// import { MappedSheetQuery } from 'records/MappedSheetQuery';
import NoLayersContent from './NoLayersContent';

type ViewMapLayers = {
  allowItemEdit: boolean;
  showAddNewLayer?: boolean;
  launchDrawingSelectionModal: VoidFunction;
  onCancelClick: VoidFunction;
  queriedMappedSheetsCount: number;
  startingSortField: string;
  startingSortDirection: 'ascending' | 'descending';
};

// const CategoryType = {
//   DISCIPLINES: 'Disciplines',
// };

// NOTE: BBCLD-6850 - Instances of FF are removed.
// Existing code is commented out to use it later in new map initiative

const ViewMapLayers: React.FC<ViewMapLayers> = ({
  allowItemEdit,
  launchDrawingSelectionModal,
  onCancelClick,
  queriedMappedSheetsCount,
  showAddNewLayer,
  startingSortField,
  startingSortDirection,
}) => {
  const [visibleLayersHistory, setVisibleLayersHistory] = useState<
    Immutable.Set<string>
  >(Immutable.Set<string>());

  // const [filterCategories, setFilterCategories] = useState<
  //   Array<FilterCategory>
  // >([]);

  const mapLayersManager = useMapLayersManager();
  const { translate } = useTranslator(['mapView', 'disciplineFilterSection']);
  // const [sortOptions, setSortOptions] = useState<[string, string][]>([]);

  const {
    visibleMappedSheetVersions,
    setVisibleMappedSheetVersions,
    // mappedSheetQuery,
    // setMappedSheetQuery,
    mappedSheetVersions,
    // getMappedSheetsDisciplines,
  } = mapLayersManager;

  const saveVisibility = (visible: boolean, pageId: string) => {
    let nextMappedSheetVersionIds: any;
    if (visible) {
      nextMappedSheetVersionIds = visibleMappedSheetVersions.add(pageId);
    } else {
      nextMappedSheetVersionIds = visibleMappedSheetVersions.delete(pageId);
    }
    setVisibleLayersHistory(nextMappedSheetVersionIds);
    setVisibleMappedSheetVersions(nextMappedSheetVersionIds);
  };

  // const getDisciplines = async () => {
  //   const disciplinesCategoryOptions = getMappedSheetsDisciplines().map((o) => {
  //     return {
  //       name: o.description,
  //       value: o.key,
  //       size: o.size,
  //     };
  //   });

  //   const translatedOptions = disciplinesCategoryOptions.map((discipline) => {
  //     const translatedDiscipline: `${string}:${string}` =
  //       `disciplineFilterSection:disciplines.${discipline.name}` as `${string}:${string}`;
  //     return {
  //       name: translate(translatedDiscipline, {
  //         defaultValue: discipline.name,
  //       }),
  //       value: discipline.value,
  //       size: discipline.size,
  //     };
  //   });
  //   const disciplinesCategory = {
  //     name: translate('mapView:labels.disciplines'),
  //     options: translatedOptions,
  //   };
  //   setFilterCategories([disciplinesCategory]);
  // };

  useEffect(() => {
    const lastModifiedLayerScale = localStorage.getItem(
      'lastModifiedLayerScale'
    );

    if (!lastModifiedLayerScale) {
      return;
    }

    if (mappedSheetVersions.size < 1 && lastModifiedLayerScale) {
      localStorage.removeItem('lastModifiedLayerScale');
    }
  }, [mappedSheetVersions]);

  // useEffect(() => {
  //   getDisciplines();
  // }, []);

  const projectManager = useProjectManager();
  const { permissions } = projectManager.getSelectedProject();
  const [searchString, setSearchString] = React.useState('');
  // const [selectedOptions, setSelectedOptions] = React.useState<
  //   Map<string, SelectedOptionToFilter>
  // >(new Map<string, SelectedOptionToFilter>());

  const handleSearchChange = (searchValue: string) => {
    const nextQuery = mapLayersManager.mappedSheetQuery.set(
      'search',
      searchValue
    );

    mapLayersManager.setMappedSheetQuery(nextQuery);
  };

  // const handleOnApplyFilter = async (
  //   filterOptionsSelected: Map<string, SelectedOptionToFilter>
  // ) => {
  //   const queryToApply = {
  //     sortField: mappedSheetQuery.sortField,
  //     sortDirection: mappedSheetQuery.sortDirection,
  //     search: mappedSheetQuery.search,
  //     disciplines: mappedSheetQuery.disciplines,
  //     disciplineSearch: mappedSheetQuery.disciplineSearch,
  //   };

  //   filterOptionsSelected.forEach((filterOption) => {
  //     if (filterOption.origin === CategoryType.DISCIPLINES) {
  //       const disciplinesPart = filterOptionsSelected.get(
  //         CategoryType.DISCIPLINES
  //       );
  //       if (disciplinesPart) {
  //         queryToApply.disciplines = Immutable.Set<string>(
  //           disciplinesPart.value
  //         );
  //       }
  //     }
  //   });
  //   await setMappedSheetQuery(new MappedSheetQuery(queryToApply));
  //   setSelectedOptions(filterOptionsSelected);
  // };

  // const handleOnResetFilter = async () => {
  //   const query = new MappedSheetQuery({
  //     sortField: mappedSheetQuery.sortField,
  //     sortDirection: mappedSheetQuery.sortDirection,
  //     search: mappedSheetQuery.search,
  //     disciplines: Immutable.Set<string>(),
  //     disciplineSearch: mappedSheetQuery.disciplineSearch,
  //   });
  //   setMappedSheetQuery(query);
  //   setSelectedOptions(new Map<string, SelectedOptionToFilter>());
  // };

  // const isFilterApplied = () => {
  //   const hasMappedSheetQueryDisciplines =
  //     mappedSheetQuery.disciplines.size > 0;
  //   return hasMappedSheetQueryDisciplines;
  // };

  return (
    <div className="column h100">
      <OverlayHeader
        id="view-map-layers-overlay-header"
        onCancelClick={onCancelClick}
        title={translate('mapView:viewMapLayers.layerList')}
      />
      <div
        className="px4 py3 bgd-white-2 column grow-0 shrink-0 bb-width-1 bb-solid bb-light-grey-1"
        style={{ filter: 'drop-shadow(0 2px 16px rgba(0, 116, 204, 0.08))' }}
      >
        <div className="row justify-between">
          <p className="m0 mb3 bold">
            {translate('mapView:viewMapLayers.allItems')} (
            {queriedMappedSheetsCount})
          </p>
          {Boolean(searchString) && (
            <button
              className="font-primary primary-blue bold font-size-4 p0 cursor-pointer"
              style={{ background: 'none', border: 'none', outline: 'none' }}
              onClick={() => {
                setSearchString('');
                handleSearchChange('');
              }}
            >
              {translate('mapView:viewMapLayers.showAll')}
            </button>
          )}
        </div>
        <div className="w100 mt2 row justify-between items-center">
          <div className="grow-1 mr3">
            <SearchInput
              id="map-layer-list-search"
              onChange={(value) => {
                setSearchString(value);
                handleSearchChange(value);
              }}
              value={searchString}
            />
          </div>

          {/* <div className="mr3">
              <Filter
                categories={filterCategories}
                selectedOptionsToFilter={selectedOptions}
                onApplyFilter={handleOnApplyFilter}
                onResetFilter={handleOnResetFilter}
                isFilterApplied={isFilterApplied()}
              />
            </div> */}

          <SortButton
            id="map-layers-sort-btn"
            sortOptions={[
              [
                `${translate('mapView:viewMapLayers.layerCreationDate')}`,
                'creationDate',
              ],
            ]}
            startingSortField={startingSortField}
            startingSortDirection={startingSortDirection}
          />
        </div>
      </div>
      {mapLayersManager.getCurrentMappedSheetEntries().size ? (
        <>
          <LayerList
            allowItemEdit={allowItemEdit}
            mapLayerContext={mapLayersManager}
            saveVisibility={saveVisibility}
            visibleLayers={visibleLayersHistory}
          />
          {showAddNewLayer && permissions.createMapLayer && (
            <div className="row p3 bgd-white-2 justify-end items-center grow-0 shrink-0 bt-width-1 bt-solid bt-light-grey-1">
              <Button
                id="map-create-new-layer-btn"
                variant="secondary"
                onClick={launchDrawingSelectionModal}
                size="large"
              >
                <ThinPlus />
                <span className="pl1">
                  {translate('mapView:viewMapLayers.createNewLayer')}
                </span>
              </Button>
            </div>
          )}
        </>
      ) : (
        <NoLayersContent onCreateLayerClick={launchDrawingSelectionModal} />
      )}
    </div>
  );
};

export default ViewMapLayers;
